import React, { Suspense, lazy, memo } from 'react'
import type { Props } from './app.types';
import EmbedOverlay from '../component/embedOverlay';
import Fade from '../utils/fade';
import { VideoOverlay } from './app.styles';
import Overlay from '../component/overlay';
const HotSpots = lazy(() => import('../component/hotspots'))
const TimeTriggers = lazy(() => import('../component/timeTriggers'))

const App = memo(({
  video,
  togglePlay,
  hotspots,
  currentFrame,
  currentTime,
  fps,
  interactions,
  pause,
  skip,
  id,
  overlays,
  toggleOverlay,
  activeOverlay,
  play,
  hotspotDesign,
  tagId,
  playing,
  hotspotIsClicked,
  hotspotClickout,
  overlayEvent,
  isOverlayClosed,
  // closeOverlayBool,
  closeOverlayAndAnimateOut,
  embedOverlay,
  closeEmbedOverlay,
  triggerSpriteId,
  forceSpriteIdShown,
  setForceSpriteIdShown,
  isImage,
  // prevFrame,
  noCustomisations,
  hideMainPlayButton,
  playerWidth,
  playerHeight,
  assetWidth,
  assetHeight,
  customParams,
  customPlayer,
} : Props) => (
  <>
    {!noCustomisations && (
      <Suspense fallback="">
        <TimeTriggers
          closeOverlayAndAnimateOut={closeOverlayAndAnimateOut}
        />
      </Suspense>
    )}
    {Object.entries(activeOverlay).length > 0 ? (
      <Overlay
        overlayEvent={overlayEvent}
        play={play}
        skip={skip}
        toggleOverlay={toggleOverlay}
        closeOverlayAndAnimateOut={closeOverlayAndAnimateOut}
        isImage={isImage}
        assetWidth={assetWidth}
        assetHeight={assetHeight}
        customParams={customParams}
        customPlayer={customPlayer}
      />
    ) : (
      <>
        {/* FIXME: VideoOverlay seems to control media area click toggle play, shouldn't be part of interactivity app */}
        { !isImage
          ? (
            <VideoOverlay
              className="videoOverlay"
              onClick={togglePlay}
            />
          ) : (
            <VideoOverlay
              className="videoOverlay"
            />
          )
        }
        {!noCustomisations && (hideMainPlayButton || isImage) && (
          <Suspense fallback="">
            <HotSpots
              className="hotspots"
              currentFrame={currentFrame}
              currentTime={currentTime}
              fps={fps}
              hotspots={hotspots}
              hotspotIsClicked={hotspotIsClicked}
              hotspotClickout={hotspotClickout}
              id={id}
              interactions={interactions}
              overlays={overlays}
              playing={playing}
              pause={pause}
              play={play}
              skip={skip}
              toggleOverlay={toggleOverlay}
              videoHotspotDesign={hotspotDesign}
              videoTagId={tagId}
              triggerSpriteId={triggerSpriteId}
              forceSpriteIdShown={forceSpriteIdShown}
              setForceSpriteIdShown={setForceSpriteIdShown}
              isImage={isImage}
              customPlayer={customPlayer}
              closeOverlayAndAnimateOut={closeOverlayAndAnimateOut}
            />
          </Suspense>
        )}
        {/* FIXME: EmbedOverlay is trigger by control/share/embed configuration, shouldn't be part of interactivity app */}
        <Fade show={embedOverlay}>
          <EmbedOverlay closeEmbedOverlay={closeEmbedOverlay} vidId={id} isImage={isImage} video={video} />
        </Fade>
      </>
  )}
  </>
))

export default App
